var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 10C7.4908 10 8.75 8.7408 8.75 7.1875C8.75 5.6342 7.4908 4.375 5.9375 4.375C4.3842 4.375 3.125 5.6342 3.125 7.1875C3.125 8.7408 4.3842 10 5.9375 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14062 11.5625C8.04063 11.0039 6.82656 10.7812 5.9375 10.7812C4.19609 10.7812 0.625 11.8492 0.625 13.9844V15.625H6.48438V14.9973C6.48438 14.2551 6.79688 13.5109 7.34375 12.8906C7.78008 12.3953 8.39102 11.9355 9.14062 11.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 11.25C11.2473 11.25 7.1875 12.5063 7.1875 15V16.875H19.375V15C19.375 12.5063 15.3152 11.25 13.2812 11.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 10C15.1797 10 16.7188 8.46098 16.7188 6.5625C16.7188 4.66402 15.1797 3.125 13.2812 3.125C11.3828 3.125 9.84375 4.66402 9.84375 6.5625C9.84375 8.46098 11.3828 10 13.2812 10Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWhite);
export default __webpack_public_path__ + "static/media/usersWhite.9647162158bda2156513d7619d67a19c.svg";
export { ForwardRef as ReactComponent };